import code from './code'
export default{
    data(){
        return{
            menuList: code.menuList,
            active: 0,
            currentRoute:{},
            actives: 0
        }
    },
    computed:{
        childrenMenuData(){
            return this.menuList[this.active]
        },
        childrenMenuChildren(){
            let { type } = JSON.parse(sessionStorage.getItem('userData'))
            const userTypes = {
                0: 'admin',
                1: 'teacher'
            }
            return this.childrenMenuData.children.filter(item=>{
                if(!item.auth.includes(userTypes[type])){
                    return false
                }else{
                    return true
                }
            })
        }
    },
    methods: {
        changeRouter(){
            let parentData = this.menuList.find(item=>item.children.find(itemc=>itemc.path===this.$route.path))
            let childrenData = parentData.children.find(item=>item.path===this.$route.path)
            this.currentRoute = {
                parentName: parentData.name,
                name: childrenData.name,
                id: parentData.id
            }
            this.active = parentData.id
            this.actives = childrenData.id
        }
    },
}